<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-input
              name="title"
              type="text"
              label="Nome Documento"
              v-model="filter.byAttribute.title"
              placeholder="Inserisci un nome documento"
            />
          </div>
          <div class="filter-item">
            <base-input
              name="note"
              type="text"
              label="Descrizione Documento"
              v-model="filter.byAttribute.note"
              placeholder="Inserisci una descrizione documento"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-input
              name="metadata"
              type="text"
              label="Metadati"
              v-model="filter.byAttribute.metadata"
              placeholder="Inserisci metadati"
            />
            <base-select
              name="document_type"
              label="Tipologia Documento"
              :options="documentTypeOptions"
              v-model="filter.byAttribute.document_type"
            />
          </div>
          <div class="filter-item">
            <base-input
              name="title"
              type="text"
              label="Nominativo"
              v-model="filter.byRegistry.title"
              placeholder="Inserisci un nominativo"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-input
              name="cf"
              type="text"
              label="Codice Fiscale"
              v-model="filter.byRegistry.NINO"
              placeholder="Inserisci un codice fiscale"
            />
            <base-input
              name="piva"
              type="text"
              label="Partita IVA"
              v-model="filter.byRegistry.CREG"
              placeholder="Inserisci una partita IVA"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>
    <documents
      :fields="fields"
      @manualFetch="manualFetch"
      :repository="repository"
      :resource="resource"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :filterName="filterName"
      :ref="tableRef"
      :filterOn="{
        byRelations: ['byCategory', 'byRegistry'],
      }"
      @download="downloadDocument"
      noActions
    ></documents>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import Documents from "@/components/tables/Documents.vue";
import { mapActions } from "vuex";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, DocumentsMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "document",
      resource: "documents",
      context: "documents_registries",
      tableRef: "RegistryDocumentFilter",
      filterName: "filterRegistryDocument",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      documentTypeOptions: [
        { value: 0, text: "Privacy" },
        { value: 1, text: "Generico" },
        { value: 2, text: "Documento di Identità" },
      ],
      fields: [
        {
          key: "customer",
          label: this.getDictionary("customer_name"),
        },
        {
          key: "tax_code",
          label: this.getDictionary("attribute_NINO_value", "registry"),
        },
        {
          key: "piva",
          label: this.getDictionary("attribute_CREG_value", "registry"),
        },
        {
          key: "title",
          label: this.getDictionary("title", "document"),
        },
        {
          key: "note",
          label: this.getDictionary("note", "document"),
        },
        {
          key: "document_type.text",
          label: this.getDictionary("document_type", "document"),
        },
        {
          key: "category",
          label: this.getDictionary("category", "document"),
        },
        {
          key: "metadata",
          label: this.getDictionary("metadata", "document"),
        },
        {
          key: "download",
          label: this.getDictionary("download", "generated_report"),
          tdClass: "text-center",
          thStyle: {
            width: "125px",
          },
        },
      ],
    };
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  components: {
    BaseIcon,
    Documents,
    BaseInput,
    BaseSelect,
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          title: null,
          note: null,
          metadata: null,
          document_type: null,
        },
        byRegistry: {
          title: null,
          NINO: null,
          CREG: null,
        },
        byOnlyRelation: "registry",
      };
      return init;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byOnlyRelation"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
};
</script>
